import React, { useState } from "react";
import { useSelector } from "react-redux";
import WhitelistAdminAuth from "./WhitelistAdminAuth";
import WhitelistDomainContent from "./WhitelistDomainContent";

function WhitelistDomainPage() {
  const { adminAuth } = useSelector((state) => state.user);
  const [config, setConfig] = useState(adminAuth ? false : true);
  return (
    <div className="w-full flex flex-col bg-white items-center justify-center p-2 lg:p-4">
      <div className="max-w-7xl w-full">
        {config ? (
          <WhitelistAdminAuth callback={() => setConfig(false)} />
        ) : (
          <WhitelistDomainContent onSet={() => setConfig(true)} />
        )}
      </div>
    </div>
  );
}

export default WhitelistDomainPage;
